import { render } from "./ProfileUserLimits.vue?vue&type=template&id=2cad5d1c"
import script from "./ProfileUserLimits.vue?vue&type=script&lang=js"
export * from "./ProfileUserLimits.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__